import { render, staticRenderFns } from "./service-order-edit.vue?vue&type=template&id=519363a4&scoped=true"
import script from "./service-order-edit.vue?vue&type=script&lang=js"
export * from "./service-order-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519363a4",
  null
  
)

export default component.exports